import {Navigate, Outlet, useNavigate, useLocation} from 'react-router-dom';
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useHotkeys } from 'react-hotkeys-hook';
import { authService } from '../api/auth';
import { CircularProgress, Box, Toolbar } from '@mui/material';
import { Navbar } from './Navbar';
import { MusicPlayerProvider } from './music/MusicPlayerContext';
import { MiniPlayer } from './music/PlayerControls';

export const ProtectedRoute = () => {
    const navigate = useNavigate();
    const { data: user, isLoading, error } = useQuery({
        queryKey: ['user'],
        queryFn: authService.getMe,
        retry: false
    });

    useHotkeys(
        'alt+n, option+n',
        () => { navigate('/notes/create'); },
        { enableOnFormTags: false }
    );

    useHotkeys(
        'shift+alt+n, shift+option+n',
        () => { window.open('/notes/create', '_blank'); },
        { enableOnFormTags: false }
    );

    useEffect(() => {
        const handler = (e: KeyboardEvent) => {
            if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
            try {
                const target = e.target as HTMLElement | null;
                if (!target) return;
                const tag = target.tagName;
                if (tag === 'INPUT' || tag === 'TEXTAREA' || ((target as HTMLElement & { isContentEditable?: boolean }).isContentEditable)) return;
                const el = document.getElementById('global-note-search-input') as HTMLInputElement | null;
                if (el) {
                    e.preventDefault();
                    el.focus();
                    try { el.select(); } catch (_err) { /* ignore */ }
                }
            } catch (_err) {
                // swallow errors
            }
        };

        document.addEventListener('keydown', handler);
        return () => document.removeEventListener('keydown', handler);
    }, []);


    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    const location = useLocation();

    if (error || !user) {
        return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    }

    return (
        <MusicPlayerProvider>
            <Navbar />
            <Toolbar />
            <Outlet />
            <MiniPlayer />
        </MusicPlayerProvider>
    );
}; 
